/**
 * @sw-package innovation
 */

declare var window: StorefrontWindow;

const PluginManager = window.PluginManager;

PluginManager.register('NaturalLanguageSearch', () => import('./plugin/natural-language-search.plugin'), '[data-natural-language-search]');
PluginManager.register('ImageUploadSearch', () => import('./plugin/image-upload-search.plugin'), '[data-image-upload-search]');
